

export const headCellsReview = [
  {
    id: 'id',
    left: false,
    disablePadding: false,
    minWidth: 160,
    label: 'SKU ID / Title',
  },
  {
    id: 'reviewsStats',
    minWidth: 100,
    label: 'Reviews Stats',
    tooltip: 'reviewsStats'
  },
  
  {
    id: 'summary',
    minWidth: 500,
    label: 'Auto-Generated Summary of Customer Reviews', 
  },
  {
    id: 'score',
    minWidth: 110,
    label: 'Insight Scores',
    tooltip: 'insightScore'
  },
  {
    id: 'bsci',
    minWidth: 80,
    label: 'Brand-Safe Confidence Index',
    tooltip: 'bsci'
  },
  {
    id: 'themes',
    minWidth: 400,
    label: 'Auto-Generated Themes',
  },
  {
    id: 'content_status',
    minWidth: 80,
    label: 'Status',
    enableSort: true
  },
  {
    id: 'lastModified',
    minWidth: 70,
    label: 'Last Updated',
  }
];

export const headCellsPdpFaq = [
  {
    id: 'id',
    left: false,
    disablePadding: false,
    minWidth: 160,
    label: 'SKU ID / Title'
  },
  {
    id: 'itemCheck',
    minWidth: 30,
    label: ' ',
    className: 'rmRightBd'
  },
  {
    id: 'summary',
    minWidth: 600,
    label: 'Review PDP FAQs',
    className: 'rmLeftBd' 
  },
  {
    id: 'score',
    minWidth: 110,
    label: 'Insight Scores',
    tooltip: 'insightScore'
  },
  {
    id: 'bsci',
    minWidth: 50,
    label: 'Brand-Safe Confidence Index',
    tooltip: 'bsci'
  },
  {
    id: 'content_status',
    minWidth: 80,
    label: 'Status',
    enableSort: true
  },
  {
    id: 'lastModified',
    minWidth: 70,
    label: 'Last Updated',
    enableOrderBy: true
  }
];


export const headCellsSiteFaq = [
  {
    id: 'q&a',
    minWidth: 600,
    label: 'Review Site-wide/Brand FAQs',
  },
  {
    id: 'score',
    minWidth: 110,
    label: 'Insight Scores',
    tooltip: 'insightScore',
  },
  {
    id: 'bsci',
    minWidth: 50,
    label: 'Brand-Safe Confidence Index',
    tooltip: 'bsci',
  },
  {
    id: 'content_status',
    minWidth: 80,
    label: 'Status',
    enableSort: true
  },
  {
    id: 'lastModified',
    minWidth: 70,
    label: 'Last Updated',
  }
];